<div class="form-group-block">
    <div id="form-top-content">
        <div class="form-group">
            <label>Title</label>
            <textarea [(ngModel)]="card.title" class="form-control" placeholder="Enter title" rows="2"></textarea>
        </div>
        <div class="form-group" *ngIf="showTitleDe">
            <label>Title (DE)</label>
            <textarea [(ngModel)]="card.title_de" class="form-control" placeholder="Enter title" rows="2"></textarea>
        </div>
        <ng-container *ngIf="card.tags">
            <ng-container *ngFor="let tag of card.tags">
                <div class="form-group">
                    <label>{{tag.popup}}</label>
                    <input type="text" [(ngModel)]="tag.text" class="form-control" placeholder="Enter text" />
                </div>
            </ng-container>
        </ng-container>
        <div class="form-group">
            <label>Date</label>
            <input type="text" [(ngModel)]="card.date" class="form-control" placeholder="Enter date" />
        </div>
        <div class="form-group">
            <label>URL</label>
            <input type="text" [(ngModel)]="card.url" class="form-control" placeholder="Enter url" />
        </div>
    </div>
    <div class="form-group">
        <label>Summary</label>
        <div id="tuiSummaryEditor"></div>
        <!--<textarea [(ngModel)]="card.abstract" class="form-control" placeholder="Enter summary" rows="4"></textarea>-->
    </div>
</div>
